/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateThermoformingInsoleDto } from '../../models/create-thermoforming-insole-dto';
import { ThermoformingInsole } from '../../models/thermoforming-insole';

export interface CreateOneBaseMgmtThermoformingInsoleControllerThermoformingInsole$Params {
      body: CreateThermoformingInsoleDto
}

export function createOneBaseMgmtThermoformingInsoleControllerThermoformingInsole(http: HttpClient, rootUrl: string, params: CreateOneBaseMgmtThermoformingInsoleControllerThermoformingInsole$Params, context?: HttpContext): Observable<StrictHttpResponse<ThermoformingInsole>> {
  const rb = new RequestBuilder(rootUrl, createOneBaseMgmtThermoformingInsoleControllerThermoformingInsole.PATH, 'post');
  if (params) {
    rb.body(params.body, 'multipart/form-data');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ThermoformingInsole>;
    })
  );
}

createOneBaseMgmtThermoformingInsoleControllerThermoformingInsole.PATH = '/api/mgmt/thermoforming-insole';
